import EventEmitter from "eventemitter3";
import { onUnmounted } from "vue";
import type * as Misskey from "calckey-js";

export type MagEventBusEvent = {
    followeeProcessed: Misskey.entities.User;
    navigated: string;
};

export const globalEvents = new EventEmitter<MagEventBusEvent>();

export function useMagEventBus<T extends keyof MagEventBusEvent>(
    key: T,
    handler: EventEmitter.EventListener<MagEventBusEvent, T>,
    context?: any,
) {
    globalEvents.on(key, handler, context);

    onUnmounted(() => {
        globalEvents.off(key, handler);
    });
}

export const deckGlobalEvents = new EventEmitter();
